import { render, staticRenderFns } from "./CourseByBuy.vue?vue&type=template&id=5e244c67&scoped=true&"
import script from "./CourseByBuy.vue?vue&type=script&lang=js&"
export * from "./CourseByBuy.vue?vue&type=script&lang=js&"
import style0 from "./CourseByBuy.vue?vue&type=style&index=0&id=5e244c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e244c67",
  null
  
)

export default component.exports